import styled from 'styled-components';
import { Button } from 'components/atoms/button';

export const GroupIndicatorIcon = styled.div`
  padding-right: var(--spacing-05);
  display: flex;
  svg {
    margin: 0;
    fill: var(--gray-50);
  }
  color: var(--gray-50);
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  padding-left: var(--spacing-05);
  top: 50%;
  position: relative;
  transform: translateY(-50%);
`;

export const StickyHeaderWrapper = styled.div`
  left: 0;
  right: 0;

  .sticky {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #fff;
    height: 36px;
    color: var(--gray-50) !important;
    &:hover {
      background: var(--coolest-gray-10) !important;
    }
  }
`;

export const StyledTrigger = styled(Button).attrs({
  size: 'middle',
  type: 'text',
})`
  width: 240px;
  padding-left: var(--spacing-03);
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  svg {
    margin-left: var(--spacing-03);
    color: var(--gray-40);
  }
`;
